module.exports = __webpack_public_path__ + "src/assets/img/appstore.b392c01f.svg";